import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  EditButton,
  DateField,
  Resource,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  Show,
  Filter,
  Pagination,
  Datagrid } from "react-admin";

const Filters = (props) => {
  return(
    <Filter {...props}>
      <TextInput label="Search by article" source="article.name" alwaysOn />
      <TextInput label="Search by material" source="material.name" alwaysOn />
      <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} alwaysOn>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  )
};

const ArticleMaterialList = (props) => {
  return (
    <List 
      {...props} 
      filters={Filters(props)}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
      bulkActionButtons={false}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <TextField source="project.name" label="Project" />
          <TextField label="Article" source="article.name" />
          <TextField label="Material" source="material.name" />
          <TextField source="amount" />
          <TextField label="Account" source="account.name" />
          <EditButton />
        </Datagrid>
    </List>
  );
};

const ShowArticleMaterial = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField label="Article" source="article.name" />
        <TextField label="Material" source="material.name" />
        <TextField source="amount" />
        <TextField label="Account" source="account.name" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        <EditButton />
      </SimpleForm>
    </Show>
  );
};

const CreateArticleMaterial = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput label="Article" source="articleId" reference="articles" filterToQuery={searchText => ({ name: searchText })}>
          <AutocompleteInput optionText="name" required={true} />
        </ReferenceInput>
        <ReferenceInput label="Material" source="materialId" reference="material" filterToQuery={searchText => ({ name: searchText })}>
          <AutocompleteInput optionText="materialName" required={true} />
        </ReferenceInput>
        <TextInput source="amount" required={true} />
      </SimpleForm>
    </Create>
  );
};

const EditArticleMaterial = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ReferenceInput label="Article" source="articleId" reference="articles" filterToQuery={searchText => ({ name: searchText })}>
          <AutocompleteInput optionText="name" required={true} />
        </ReferenceInput>
        <ReferenceInput label="Material" source="materialId" reference="material" filterToQuery={searchText => ({ name: searchText })}>
          <AutocompleteInput optionText="materialName" required={true} />
        </ReferenceInput>
        <TextInput source="amount" required={true} />
      </SimpleForm>
    </Edit>
  );
};



const articleMaterialResource = () => <Resource
  name="articleMaterial"
  options={{ label: 'Article material', menuGroup: 'Articles' }}
  list={ArticleMaterialList}
  create={CreateArticleMaterial}
  edit={EditArticleMaterial}
  show={ShowArticleMaterial} />;

export default articleMaterialResource;
